<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-08-01 
-->
<template>
  <div class="main-container">
    <page-header>{{'展商名录' | dealLanguage('Exhibitor List')}}</page-header>
    <div class="entitys-list">
      <div class="entitys-list-item" v-for="item,index in list" :key="index">
        <div class="entitys-name">
          <img :src="`${static_img_url}pic/org-title-lt.png`" class="ltimg" />
          <span>{{item.name}}</span>
          <img :src="`${static_img_url}pic/org-title-rt.png`" class="rtimg" />
        </div>
        <div class="entitys">
          <entity-item v-for="item2,index2 in item.list" :key="index2" :itemDetail="item2"></entity-item>
        </div>
      </div>
    </div>
    <div ref="indexlist-bottom"></div>
  </div>
</template>
<script>
import { getActExhibition } from '@/service/vbef'
import PageHeader from '@/components/mobile/pageHeader.vue'
import EntityItem from '@/components/index/entityItem.vue'
import { mapState } from 'vuex'
import filter from 'js/filter'
export default {
  metaInfo(){
    return {
      title: this.language == 'zh' ? '展商名录' : 'Exhibitor List', 
    }
  },
  inject: ['wxShare'],
  components: {
    PageHeader,
    EntityItem,
  },
  created() {
    this.getActExhibition()
  },
  mounted() {
    this.wxShare({
      title: filter.dealLanguage('展商名录-CSGCT', 'Exhibitor List-CSGCT'),
      linkurl: this.vbef_path + '/exhibitors',
      
    })
  },
  data() {
    return {
      list: [],
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      vbef_path: (state) => state.vbef_path,
      activityId: (state) => state.activityId,
      language: (state) => state.language,
    }),
  },
  methods: {
    async getActExhibition() {
      let res = await getActExhibition({
        activityId: this.activityId,
      })
      if (res.code == 0) {
        let list = res.data.orgDtos
        let arr = []
        list.forEach((item) => {
          let index = arr.findIndex((ele) => ele.name == item.name)
          if (index == -1) {
            arr.push({ name: item.name, sortNum: item.sortNum, list: [item] })
          } else {
            arr[index].list.push(item)
          }
        })
        // arr 按照arr.sortNum排序
        arr.sort((a, b) => a.sortNum - b.sortNum)

        this.list = [...arr]
      }
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-m.styl'
.entitys-list
  padding 0.4rem
  .entitys-name
    line-height 1
    display flex
    align-items center
    justify-content center
    img
      width 0.55rem
    span
      font-size 0.39rem
      color #C8161D
      margin 0 0.05rem
  .entitys-list-item
    &+div
      margin-top 0.3rem
.entitys
  margin-top 0.3rem
  display grid
  grid-template-columns repeat(3, 1fr)
  grid-gap 0.3rem 0.3rem
  >>> .entity-item
    width auto
    max-width none
    height 0.9rem
</style>